import { render, staticRenderFns } from "./TopAnalysts.vue?vue&type=template&id=049a7baa&"
import script from "./TopAnalysts.vue?vue&type=script&lang=js&"
export * from "./TopAnalysts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports